module.exports = __webpack_public_path__ + "images/stickers/taco-cool.f41573409925dd066cb5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-cool.png
// module id = 2klM
// module chunks = 13